import { Flame as FlameIcon } from "lucide-react";

export function Flame({ className = "h-5 w-5" }) {
  return <FlameIcon className={className} strokeWidth={2.25} />;
}

export function Logo({ withText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="grid place-items-center h-9 w-9 rounded-xl bg-[#4B2BB8]" data-testid="app-logo-mark">
        <img src="/ember-flame-white.png" alt="" aria-hidden className="h-5 w-auto" />
      </div>
      {withText && (
        <div className="leading-none" style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}>
          <div className="font-extrabold text-[17px] tracking-tight text-[#1A1530]">Ember Compass</div>
          <div className="mt-0.5 text-[9px] font-bold uppercase tracking-[0.18em] text-[#7B61E0]">Selective &amp; JMSS Entry</div>
        </div>
      )}
    </div>
  );
}
